/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
import { buildTask as _buildTask } from "ember-concurrency/async-arrow-runtime";
var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Store from "@ember-data/store";
import { service } from "@ember/service";
import { underscore } from "@ember/string";
import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import DmpDocumentRetrievedJournalEvent from "cnam/models/dmp-document-retrieved-journal-event";
import BioExamResultsReceivedJournalEvent from "core/models/bio-exam-results-received-journal-event";
import ConsultationReportWrittenJournalEvent from "core/models/consultation-report-written-journal-event";
import FileAttachment from "core/models/file-attachment";
import FileUploadedJournalEvent from "core/models/file-uploaded-journal-event";
import JournalEvent from "core/models/journal-event";
import extensionFromMimeType from "core/utils/extension-from-mime-type";
import dayjs from "dayjs";
import { task } from "ember-concurrency";
let FileAttachmentDownloader = (_class = class FileAttachmentDownloader extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "store", _descriptor, this);
    _initializerDefineProperty(this, "shouldShowErrorMessage", _descriptor2, this);
    /**
     * Given the fileAttachmentId, find from the database
     * the related File attachment, and download it
     */
    _defineProperty(this, "downloadFileFromFileAttachmentTask", _buildTask(() => ({
      context: this,
      generator: function* (fileAttachment) {
        const fileContent = yield fileAttachment.fileContent;
        const journalEvent = yield fileAttachment.journalEvent;
        const mimeType = fileAttachment.mimeType;
        if (fileContent && journalEvent && mimeType) {
          const linkSource = `data:${mimeType};base64,${fileContent.data}`;
          const fileName = FileAttachmentDownloader.filename(journalEvent);
          this.processDownload(linkSource, mimeType, fileName);
        } else {
          this.shouldShowErrorMessage = true;
        }
      }
    }), null, "downloadFileFromFileAttachmentTask", null));
    /**
     * From the linkSource, download the file
     * linkSource has the format data:MIMETYPE;base64,CONTENT
     */
    _defineProperty(this, "downloadFileFromContentTask", _buildTask(() => ({
      context: this,
      generator: function* (linkSource, mimeType, fileName) {
        this.processDownload(linkSource, mimeType, fileName);
      }
    }), null, "downloadFileFromContentTask", null));
  }
  /**
   * Construct a link, populate the mandatory attributes
   * such as :
   * - linkSource, which contains the data
   * - mimeType, to determine the extension
   * - the fileName, i.e. name of the download file
   */
  processDownload(linkSource, mimeType, fileName) {
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName + extensionFromMimeType(mimeType);
    downloadLink.click();
  }
  static filename(journalEvent) {
    const formattedDate = dayjs(journalEvent.occurredAt).format("DD-MM-YYYY");
    let fileName;
    if (journalEvent instanceof ConsultationReportWrittenJournalEvent) {
      fileName = `rapport_consultation_${formattedDate}`;
    } else if (journalEvent instanceof BioExamResultsReceivedJournalEvent) {
      fileName = `resultats_biologiques_${formattedDate}`;
    } else if (journalEvent instanceof FileUploadedJournalEvent || journalEvent instanceof DmpDocumentRetrievedJournalEvent) {
      fileName = `${underscore(journalEvent.title)}_${formattedDate}`;
    } else {
      const jeName = underscore(journalEvent.constructor.name.replace(/JournalEvent/, ""));
      fileName = `${underscore(jeName)}_${formattedDate}`;
    }
    return fileName;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "shouldShowErrorMessage", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _class);
export { FileAttachmentDownloader as default };